<template>
  <div>
    <filtroChecklistsVue @filtrosSelecionados="enviarFiltros" />
    <listChecklistVue
      :subjectPermission="subjectPermission"
      :filtros="filtros"
      :realizarFiltro="realizarFiltro"
      @finalizarFiltros="finalizarFiltro"
    />
  </div>
</template>

<script>
import filtroChecklistsVue from '../../filtros/FiltroChecklists.vue';
import listChecklistVue from '../../lists/ListChecklist.vue';

export default {
  data() {
    return {
      subjectPermission: 'Checklist',
      realizarFiltro: false,
      filtros: null,
    };
  },
  methods: {
    enviarFiltros(filtro) {
      this.realizarFiltro = true;
      this.filtros = filtro;
    },
    finalizarFiltro() {
      this.realizarFiltro = false;
    },
  },
  watch: {},
  created() {},
  components: {
    filtroChecklistsVue,
    listChecklistVue,
  },
};
</script>

<style></style>
